import { type ReactNode } from 'react'
import { useCurrentUser } from '@m3-tech/boss-core'
import { AccessDeniedPage } from '@m3-tech/boss-ui'
import { DEV_SERVICE_STATUS_USER_IDS } from '@/constants/devServiceStatusAccess'

interface DevServiceStatusGuardedRouteProps {
    children: ReactNode
}

/**
 * Route guard for the Dev Service Status screen.
 *
 * The sibling internal screens (SignalR, Error Management) fall back to
 * `SecurityGroupGuardedRoute securityGroupId={SECURITY_GROUP_ADMIN}` on the route
 * while their user-id allowlist gates only the nav item. Dev Service Status has no
 * security group in legacy at all, so that fallback does not apply — and the page
 * can activate/deactivate every Creditor user, so leaving it reachable by URL for
 * any authenticated user is not acceptable. The route therefore enforces exactly
 * the same allowlist the nav item uses.
 */
export function DevServiceStatusGuardedRoute({ children }: DevServiceStatusGuardedRouteProps) {
    const currentUser = useCurrentUser()

    if (!DEV_SERVICE_STATUS_USER_IDS.has(currentUser?.id ?? -1)) return <AccessDeniedPage />

    return <>{children}</>
}
